import { FooterLink } from 'src/app/modules/auth/abstractions/footer-link';

export const FooterLinks: FooterLink[] = [
  {
    link: 'https://www.pwc.com/us/en/site/privacy.html',
    text: 'footer.privacyPolicy',
  },
  {
    link: 'https://productcentral.products.pwc.com/us/en/legal/terms-of-use.html',
    text: 'footer.termsAndConditions',
  },
];
